// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleInputConfiguration.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import Input from 'share/components/controls/Izenda.Input';
import EventsUtils from 'EventUtils';
import connect from 'share/enhancers/Izenda.Connect';
import { DEFAULT_SETTING_VALUE, LABEL_TEXT } from 'logic/data/Izenda.ReportPartChartConstants';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import action from './Izenda.SimpleInputConfigurationAction';
import { isEqual } from 'lodash/fp';

@connect(action)
export default class SimpleInputConfiguration extends Component {
  static propTypes = {
    reportPart: React.PropTypes.object.isRequired,
    dataKey: React.PropTypes.string.isRequired
  };

  /**updated font family in case of fontfamily blank (bascially it happens for 
   * the which crated in version 3.7 and open in greater than 3.8)  */
  // getUpdatedFontSettings(fontSetting, dataKey) {
  //   if (fontSetting && fontSetting.fontFamily === "") {
  //     fontSetting = DEFAULT_SETTING_VALUE.titleDescriptionNew(dataKey === 'previewTitle');
  //   }
  //   return fontSetting;
  // }

  render() {
    const props = this.props;
    const reportPart = props.reportPart;
    const dataKey = props.dataKey;
    const isGridOrMap = reportPart.type === REPORT_PART_TYPE.Grid || reportPart.type === REPORT_PART_TYPE.Map;
    const labelCols = isGridOrMap ? 3 : 12;
    const inputCols = isGridOrMap ? 9 : 12;

    const fontSetting = props.getFontSettings();

    //const updatedFontSetting = this.getUpdatedFontSettings(fontSetting, dataKey);
    const hadSetting = !(
      isEqual(fontSetting, DEFAULT_SETTING_VALUE.titleDescriptionNew(dataKey === 'previewTitle')) ||
      isEqual(fontSetting, DEFAULT_SETTING_VALUE.titleDescriptionDefault)
    );

    return (
      <GridLayout.Row>
        <GridLayout.Col cols={labelCols} xs="3">
          {LABEL_TEXT[dataKey]}
        </GridLayout.Col>
        <GridLayout.Col cols={inputCols} xs="9">
          <div className="configuration-input">
            <Input
              className="form-control"
              value={getHeaderInfo(dataKey)}
              onChange={EventsUtils.notifyChange(onChangeData, EventsUtils.INPUT)}
            />
            <a onClick={props.togglePopup}>
              <span className="icon-setting" title={props.title}>
                {hadSetting && (
                  <div className="u_floatRight u-posRelative">
                    <i className="icon-ok u_smallIcon u-hadSetting u-colorWhite u-bgGreen" />
                  </div>
                )}
              </span>
            </a>
          </div>
        </GridLayout.Col>
      </GridLayout.Row>
    );

    /**
     * Get Title/Description text
     * @returns {String}
     */
    function getHeaderInfo() {
      const re = reportPart.getDataValueByKey(dataKey);
      return re && re.text;
    }

    /**
     * Update text for previewTitle or Description
     * @param newVal
     */
    function onChangeData(newVal) {
      const fn = dataKey === 'previewTitle' ? 'updateReportPartPreviewTitle' : 'updateReportPartDescription';
      reportPart[fn] && reportPart[fn](newVal);
    }
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.SimpleInputConfiguration.js